import { Directive, inject, input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[fbSelectOption]',
})
export class SelectOption<Value> {
  /**
   * Template for the option.
   */
  public readonly template = inject(TemplateRef);

  /**
   * Value of the option.
   */
  public readonly value = input.required<Value>({ alias: 'fbSelectOptionValue' });
}
